/* eslint-disable no-console */
import {FC, useEffect, useState} from "react";
import {NotificationProvider as SSNotificationProvider} from "@buildwitt/shapeshift-identity";
import {Capacitor} from "@capacitor/core";
import {ActionPerformed, PushNotificationSchema, PushNotifications, Token} from "@capacitor/push-notifications";
import {useSetNotificationToken} from "@buildwitt/shapeshift-common/v1/hooks";

interface IProps {
	children: JSX.Element
}

const NotificationProvider: FC<IProps> = ({children}) => {
	const [platform] = useState(Capacitor.getPlatform());
	const [token, setToken] = useState<string>();
	const {setNotificationToken, apiResult} = useSetNotificationToken();

	useEffect(() => {
		if(token){
			setNotificationToken(token)
		}
	}, [token])

	const registerPush = (): void => {

		PushNotifications.requestPermissions().then((permission) => {
			if (permission.receive === "granted") {
				// Register with Apple / Google to receive push via APNS/FCM
				PushNotifications.register();
			}
		});

		PushNotifications.addListener("registration", (FCMToken: Token) => {
			setToken(FCMToken.value)
		});

		PushNotifications.addListener("registrationError", (error: any) => {
			console.error("Error on registration: ", error);
		});

		PushNotifications.addListener("pushNotificationReceived", (notification: PushNotificationSchema) => {
			// console.log("---+Push notification received: ", notification);
			//alert("---+Push notification received: " +JSON.stringify(notification))
		});

		PushNotifications.addListener("pushNotificationActionPerformed", (notification: ActionPerformed) => {
			const data = notification.notification.data;
			if (data.detailsId) {
				// this.router.navigateByUrl(`/home/${data.detailsId}`);
			}
		});
	}

	useEffect(() => {
		if (platform !== "web") {
			registerPush();
		}
	}, [])


	return (
		<SSNotificationProvider><>
			{/* <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
		TOKEN RESPONSE{JSON.stringify(apiResult)}
		<br/>
		TOKEN: {token} */}
			{children}
		</>

		</SSNotificationProvider>
	)
}

export default NotificationProvider;